/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./detail.css";
import { axiosInstanceWithToken } from "../helpers/axios";
import ListingOutOverlay from "../Components/ui/ListingOutOverlay";
import Layout from "../Components/layout/Layout";
// ---------------------------------------------
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/swiper-bundle.css";
import { PROFILE_IMAGE_SERVER_URL, SERVER_IMAGES_URL } from "../constants";

const PicProfile = () => {
  const { state } = useLocation();
  const host_id = state?.host_id;
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await axiosInstanceWithToken(`/user/${host_id}`);
      console.log(response, "responsePIC");
      setUser(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <img
          className="h-auto w-36 md:w-44" // Responsive sizes
          src="/image/fly-inn-logo.svg"
          alt="Fly Inn Logo"
        />
        <div className="text-2xl text-bold">
          {" "}
          Please Wait while we load your data!
        </div>
      </div>
    );
  }

  return (
    <Layout>
      <section
        className="main-content-area !p-10"
        style={{ backgroundColor: "rgb(247, 248, 249)" }}
      >
        <div className="container">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="bg-white col-sm-12 col-md-12">
              <div className="page-wrap">
                <div className="article-main">
                  <article
                    id="post-7550"
                    className="block single-page-article post-7550 page type-page status-publish hentry"
                  >
                    <div className="block p-8">
                      <div className="block-head">
                        <div className="media">
                          <div className="media-left">
                            <img
                              width={70}
                              height={70}
                              alt=""
                              src={
                                user?.image !== null
                                  ? `${PROFILE_IMAGE_SERVER_URL}/${user?.image}`
                                  : "images/avatar/avatar-bg.png"
                              }
                              className="img-circle w-[70px] h-[70px] lazyloaded"
                            />
                          </div>
                          <div className="media-body">
                            <h2 className="title">{user?.display_name}</h2>
                            <ul className="list-inline profile-host-info">
                              <li>
                                <address>
                                  <i
                                    className="homey-icon homey-icon-style-two-pin-marker"
                                    aria-hidden="true"
                                  />{" "}
                                  {user?.country || user?.country}
                                </address>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <h3
                        style={{
                          display: "flex",
                          textAlign: "left",
                          marginTop: "30px",
                        }}
                      >
                        Bio
                      </h3>
                      <p style={{ padding: "0px" }}>{user?.bio || user?.bio}</p>
                      <div className="">
                        <div className="row">
                          <div className="text-left col-md-3">
                            <dl>
                              <dt>Native / Fluent Languages</dt>
                              <dd>
                                {user?.native_language || user?.native_language}
                              </dd>
                            </dl>
                          </div>
                          <div className="text-left col-md-3">
                            <dl>
                              <dt>Other Languages</dt>
                              <dd>
                                {user?.other_language || user?.other_language}
                              </dd>
                            </dl>
                          </div>
                          <div className="text-left col-md-3">
                            <dl>
                              <dt>Profile Status</dt>
                              <dd className="text-success">
                                <i className="fa fa-check bg-[#8ec639] p-1 !text-white rounded-full" />
                                Verified
                              </dd>
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="px-8 pb-10 bg-white row">
            <h2 className="my-30">Listings</h2>

            {/* <Swiper
              spaceBetween={30}
              slidesPerView={3}
              navigation
              modules={[Navigation]}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            > */}
            <div className="grid grid-cols-4 gap-6">
              {user?.listings?.map((e, index) => (
                <div className="col-span-1">
                  <ListingOutOverlay e={e} key={index} />
                </div>
              ))}
            </div>

            {/* </Swiper> */}
          </div>
        </div>{" "}
      </section>
    </Layout>
  );
};

export default PicProfile;
